[
    {
        "Select": {
            "editable": false,
            "pinned": "left",
            "refData": {
                "datatype": "checkbox",
                "selectAll": true,
                "colSize": 50
            },
            "maxWidth": 50,
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Style-Color": {
            "editable": false,
            "refData": {
                "custom_field": "style_color",
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Channel": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Size Range": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Reco Qty": {
            "editable": false,
            "refData": {
                "datatype": "integer",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Deliveries": {
            "editable": false,
            "refData": {
                "datatype": "object",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false,
            "autoHeight": true
        }
    }
]
